import type { useServiceAnchorLayerGate } from "./useServiceAnchorLayerGate";

type Props = {
  gate: ReturnType<typeof useServiceAnchorLayerGate>;
};

export function ServiceGateBanner({ gate }: Props) {
  if (gate.loading) {
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100">
        Loading service data…
      </div>
    );
  }
  if (gate.error) {
    return (
      <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/35 dark:text-red-100">
        {gate.error}
      </div>
    );
  }
  if (!gate.enabled) {
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100">
        Service requires an active Turbo Sales or Turbo Manufacturing entitlement for this organization.
      </div>
    );
  }
  return null;
}
